module.exports = __webpack_public_path__ + "static/media/atos.6f4a7be9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/atos.jpg
// module id = 253
// module chunks = 0